import { formatRevenue, formatRevenueWithSign } from "../../../utils/revenueFormat";
import "../../../css/SubscriptionDetailTable.css";

// 컬럼 헤더 ? 툴팁 문구 (모바일에서는 hover가 없으므로 표 아래 각주로 함께 노출)
const REFUND_HINT = "정기 결제 후 7일 이내에 'Free' 등급으로 강제 전환된 건의 차감액";
const VOLUNTARY_CANCEL_HINT =
  "결제 후 7일을 초과한 시점에 구독을 해지하거나 Free로 전환한 건수. 순 매출 계산에는 영향 없는 참고 지표.";

function SubscriptionDetailTable({ subscriptionDetail }) {
  if (!subscriptionDetail) return null;

  const grades = [
    { key: "basic",    label: "Basic",    color: "#85B7EB" },
    { key: "standard", label: "Standard", color: "#378ADD" },
    { key: "premium",  label: "Premium",  color: "#185FA5" },
  ];

  const renderMom = (mom) => {
    if (mom == null) return <span className="sub-mom-neutral">기준월</span>;
    if (Math.abs(mom) < 0.0005) return <span className="sub-mom-neutral">— 0.0%</span>;
    const pct = (mom * 100).toFixed(1);
    if (mom > 0) {
      return <span className="sub-mom-up">▲ {pct}%</span>;
    }
    return <span className="sub-mom-down">▼ {Math.abs(pct)}%</span>;
  };

  return (
    <>
      <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
        <table className="sub-detail-table">
          <thead>
            <tr>
              <th>등급</th>
              <th>신규 가입</th>
              <th>갱신</th>
              <th>
                <span className="th-hint-wrap">
                  환불
                  <span className="th-hint-icon">?</span>
                  <span className="th-hint-popup">{REFUND_HINT}</span>
                </span>
              </th>
              <th>
                <span className="th-hint-wrap">
                  자발적 해지
                  <span className="th-hint-icon">?</span>
                  <span className="th-hint-popup">{VOLUNTARY_CANCEL_HINT}</span>
                </span>
              </th>
              <th>순 매출</th>
              <th>MoM</th>
            </tr>
          </thead>
          <tbody>
            {grades.map(({ key, label, color }) => {
              const data = subscriptionDetail[key] || {};
              const newAmount = data.newAmount ?? 0;
              const newCount = data.newCount ?? 0;
              const renewAmount = data.renewAmount ?? 0;
              const renewCount = data.renewCount ?? 0;
              const refundCount = data.refundCount ?? 0;
              const refundAmount = data.refundAmount ?? 0;
              const voluntaryCancelCount = data.voluntaryCancelCount ?? 0;
              const netRevenue = data.netRevenue ?? 0;
              const mom = data.mom ?? null;

              return (
                <tr key={key}>
                  <td className="sub-grade-cell">
                    <span className="sub-grade-dot" style={{ backgroundColor: color }} />
                    <span className="sub-grade-name">{label}</span>
                  </td>
                  <td className="sub-amount">
                    <div>{formatRevenueWithSign(newAmount)}</div>
                    <div className="sub-count">({newCount}건)</div>
                  </td>
                  <td className="sub-amount">
                    <div>{formatRevenueWithSign(renewAmount)}</div>
                    <div className="sub-count">({renewCount}건)</div>
                  </td>
                  <td className="sub-amount sub-refund">
                    <div>{refundAmount > 0 ? `-${formatRevenue(refundAmount)}` : "₩0"}</div>
                    <div className="sub-count">({refundCount}건)</div>
                  </td>
                  <td className="sub-amount sub-vcenter">
                    {voluntaryCancelCount}건
                  </td>
                  <td className={`sub-amount sub-vcenter ${netRevenue >= 0 ? "sub-positive" : "sub-negative"}`}>
                    {formatRevenueWithSign(netRevenue)}
                  </td>
                  <td className="sub-mom-cell sub-vcenter">
                    {renderMom(mom)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <ul className="th-hint-notes">
        <li><strong>※ 환불</strong> {REFUND_HINT}</li>
        <li><strong>※ 자발적 해지</strong> {VOLUNTARY_CANCEL_HINT}</li>
      </ul>
    </>
  );
}

export default SubscriptionDetailTable;
